import { useState, useEffect } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import { useTranslation } from "../context/TranslationContext";
import { getMintSpaceRating } from "../api/mintSpace";

/**
 * A space's stars: the average of its products' reviews, which only buyers can write.
 * Spaces aren't starred directly any more.
 */
export default function MintSpaceRatingStars({ mintSpaceId, isDark, compact = false }) {
  const { t } = useTranslation();
  const [averageRating, setAverageRating] = useState(null);
  const [ratingCount, setRatingCount] = useState(0);

  useEffect(() => {
    if (!mintSpaceId) return;
    getMintSpaceRating(mintSpaceId)
      .then((pub) => {
        if (pub.success && pub.data) {
          setAverageRating(pub.data.averageRating);
          setRatingCount(pub.data.ratingCount || 0);
        }
      })
      .catch(() => {});
  }, [mintSpaceId]);

  const displayAvg = averageRating != null ? averageRating : 0;
  const avgFilled = Math.min(5, Math.max(0, Math.round(displayAvg)));
  const starSize = compact ? "h-3.5 w-3.5" : "h-4 w-4";
  const gold = "text-status-warning";
  const empty = isDark ? "text-slate-600" : "text-slate-300";

  return (
    <div className={`flex flex-col gap-0.5 ${compact ? "mt-1" : "mt-2"}`}>
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-0.5" role="img" aria-label={t("mintSpace.spaceRating") || "Mint Space rating"}>
          {[1, 2, 3, 4, 5].map((i) => {
            const on = i <= avgFilled;
            const Star = on ? FaStar : FaRegStar;
            return <Star key={i} className={`${starSize} ${on ? gold : empty}`} />;
          })}
        </div>
        {ratingCount > 0 ? (
          <span className="text-footnote font-medium text-label-secondary">
            {displayAvg.toFixed(1)} · {ratingCount} {ratingCount === 1 ? t("mintSpace.review") : t("mintSpace.reviews")}
          </span>
        ) : (
          <span className="text-footnote text-label-tertiary">{t("mintSpace.noReviewsYet")}</span>
        )}
      </div>
    </div>
  );
}
